import { useI18n } from 'AurionCR/components';
import { useMemo } from 'react';

type StandardEnum<T> = {
  [id: string]: T | string;
  [nu: number]: string;
};

interface IIdValue {
  id: string;
  title: string;
}

export function useEnumToIdValue<Key extends StandardEnum<unknown>>(yourEnum: Key) {
  const { t } = useI18n();
  const ProcessTypeGroup = useMemo(() => {
    const keyValue = Object.keys(yourEnum);
    const middleOfArray = keyValue.length / 2;
    const idValue: Array<IIdValue> = [];
    for (let i = 0; i < middleOfArray; i++) {
      const keyForTranslator = keyValue[i + middleOfArray].replace(
        /[A-Z]/g,
        (str) => '-' + str.toLowerCase(),
      );
      idValue.push({ id: keyValue[i], title: t(keyForTranslator) });
    }
    return idValue;
  }, [t, yourEnum]);
  return ProcessTypeGroup;
}
